export { default } from "./ZoomControl";
